import { render, staticRenderFns } from "./page-detail-car.vue?vue&type=template&id=8789d592&scoped=true&"
import script from "./page-detail-car.vue?vue&type=script&lang=js&"
export * from "./page-detail-car.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8789d592",
  null
  
)

export default component.exports